import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
} from "@/components/ui/dialog"
import {
  Carousel, 
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import { Card, CardContent } from "@/components/ui/card"

interface IModalProps {
  toggleModal: () => void,
  exibirModal: boolean,
  imgs: string[]
}

const ModalImagemTitulo = ({ toggleModal, exibirModal, imgs }: IModalProps) => {
  return (
    <Dialog open={exibirModal} onOpenChange={toggleModal}>
      <DialogContent>
        <DialogHeader onClick={() => toggleModal()}>
          <DialogDescription className="gap-5 flex flex-col">
            <Carousel className="w-[90%] flex justify-center items-center text-center">
              <CarouselContent>
                {
                  imgs.map((img) => (
                    <CarouselItem className="flex justify-center items-center" key={img}>
                      <Card className='border-2'>
                        <CardContent className="p-3">
                          <img src={img} />
                        </CardContent>
                      </Card>
                    </CarouselItem>
                  ))
                }
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}

export default ModalImagemTitulo;